<po-page-default p-title="Consulta de pendência" [p-breadcrumb]="breadcrumb">
  <div class="po-row">
    <po-container class="po-lg-12 po-md-12 po-sm-12">
      <div class="consulta-page-actions po-mb-3">
        <po-button
          p-label="Voltar"
          p-kind="secondary"
          p-icon="an an-arrow-left"
          (p-click)="voltarPendenciaEstadual()">
        </po-button>
      </div>

      <span class="po-lg-12 po-md-12 po-sm-12 po-mb-2 po-font-text-uppercase">
        <span class="an an-robot"></span>
        Relatório de pendências estaduais
      </span>

      <div class="po-lg-12 po-mb-3">
        <po-radio-group
          p-label="Tipo de dívida estadual"
          name="tipoDivida"
          [ngModel]="tipoDivida"
          (ngModelChange)="onChangeTipoDivida($event)"
          [p-columns]="2"
          [p-options]="tipoDividaOptions">
        </po-radio-group>
      </div>

      <div class="po-lg-11 po-md-9 po-sm-8 po-mb-5 destaque">
        <p class="po-font-text-large po-mb-1">Esta tela consulta pendências estaduais (inscrita ou não inscrita).</p>
        <p><b> &nbsp;&nbsp; - Informe um código de empresa manualmente.</b></p>
        <p>
          <b>&nbsp;&nbsp; - Ou envie uma planilha (CSV/XLSX) com a coluna <i>CNPJ</i> (ex.: 74.415.183/0001-42).</b>
        </p>
        <p><b> &nbsp;&nbsp; - O sistema enviará a solicitação conforme o tipo selecionado.</b></p>
        <p>
          <b>&nbsp;&nbsp; - O andamento aparece na
            <a routerLink="/rpa">tela de RPA</a>. Use o menu (⋯) para ver o status de cada empresa.
          </b>
        </p>
      </div>

      <po-input class="po-lg-4 codigo-col" p-label="Código da Empresa" p-placeholder="Ex.: 12345"
        [(ngModel)]="codigoEmpresa" p-help="Se informar este campo, ele terá prioridade sobre o arquivo."
        p-clean="true" p-name="codigoEmpresa">
      </po-input>

      <div class="po-lg-5 planilha-col">
        <label class="po-field-title">Planilha com coluna CNPJ (CSV/XLSX)</label>
        <div class="dropzone" (drop)="onDropArquivo($event)" (dragover)="onDragOverArquivo($event)">
          Arraste o arquivo aqui ou
          <input type="file" accept=".csv,.xlsx,.xlsm,.xls" (change)="onArquivoSelecionado($event)" />
        </div>
        <p class="po-font-text" *ngIf="arquivoNome">
          Arquivo: <b>{{ arquivoNome }}</b>
          <a style="margin-left: 8px; cursor: pointer;" (click)="limparArquivo()">Limpar</a>
        </p>
      </div>

      <po-button class="po-lg-3 po-mt-4" p-label="Gerar Relatório" (p-click)="gerarRelatorioPendencias()"
        [p-loading]="loading"></po-button>

      <div class="po-lg-12 po-mt-4" *ngIf="showProgress && processamentoAtual">
        <div class="progress-section">
          <div class="progress-header">
            <i class="an an-timer"></i>
            <span>Progresso do processamento</span>
          </div>

          <div class="progress-body">
            <p class="rpa-processamento-aviso">
              <i class="an an-info"></i>
              Acompanhe também na <a routerLink="/rpa">tela de RPA</a>.
              Clique em <b>Atualizar status</b> para ver se a consulta já terminou.
            </p>
            <p class="rpa-timeline-desc po-mt-2">
              Status: <b>{{ getStatusLabel() }}</b> — {{ processoMensagem }}
            </p>

            <div class="po-row po-mt-3 pendencias-acoes-status">
              <po-button
                class="po-mr-2"
                p-label="Atualizar status"
                p-kind="secondary"
                p-icon="an an-arrows-clockwise"
                [p-loading]="sincronizandoArquivos"
                (p-click)="sincronizarArquivosRpa()">
              </po-button>
            </div>

            <div class="empresas-pendencias-list po-mt-3" *ngIf="processamentoAtual.empresas.length > 0">
              <div class="empresa-pendencia-row" *ngFor="let emp of processamentoAtual.empresas">
                <div class="empresa-pendencia-info">
                  <p class="empresa-pendencia-titulo">
                    <b>{{ emp.codigo }}</b> — {{ emp.status === 'PRONTO' ? 'Pronto' : emp.status === 'BLOQUEADO' ? 'Falha' : 'Processando' }}
                  </p>
                  <p class="empresa-pendencia-msg">{{ emp.mensagem }}</p>
                </div>
                <po-button
                  *ngIf="podeVisualizarArquivoEmpresa(emp)"
                  p-label="Visualizar arquivo"
                  p-kind="secondary"
                  p-icon="an an-eye"
                  [p-loading]="loadingArquivo"
                  (p-click)="visualizarArquivoEmpresa(emp)">
                </po-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </po-container>
  </div>
</po-page-default>
